import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { ReactComponent as LeftArrow } from '../../../image/LeftArrow.svg';
import { ReactComponent as Check3Svg } from '../../../image/Check3.svg';

export default function SelectStatusBox(props) {
  const {
    isClickedValidSorting,
    isClickedInvalidSorting,
    setIsClickedValidSorting,
    setIsClickedInvalidSorting
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClicked, setIsClicked] = useState(false);

  const ButtonRef = useRef(null);
  const SelectBoxRef = useRef(null);

  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (SelectBoxRef.current !== e.target
      && !SelectBoxRef.current.contains(e.target)
      && ButtonRef.current !== e.target
      && !ButtonRef.current.contains(e.target)) {
        setIsClicked(false);
    }
  }

  return (
    <StatusBoxWrapper>
      <StatusBox ref={ButtonRef} isClicked={isClicked} $hasSelected={isClickedValidSorting || isClickedInvalidSorting} onClick={() => setIsClicked(!isClicked)}>
        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isClicked ? theme.primary : theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.status')}</Text>
        {
          (!isClickedValidSorting && !isClickedInvalidSorting) &&
          <ArrowWrapper isClicked={isClicked}>
            <StyledArrow $isClicked={isClicked} />
          </ArrowWrapper>
        }
        {
          (isClickedValidSorting || isClickedInvalidSorting) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isClicked ? theme.primary : theme.text} hover='pointer'>:</Text>
        }
        {
          isClickedValidSorting &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isClicked ? theme.primary : theme.text} hover='pointer'>{isClickedInvalidSorting ? t('messageSend.memberSelect.filter.valid') + ',' : t('messageSend.memberSelect.filter.valid')}</Text>
        }
        {
          isClickedInvalidSorting &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isClicked ? theme.primary : theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.expired')}</Text>
        }
      </StatusBox>
      <SelectBox ref={SelectBoxRef} isClicked={isClicked} $isDark={isDark}>
        <Option onClick={() => setIsClickedValidSorting(!isClickedValidSorting)}>
          <CheckBox isClicked={isClickedValidSorting}>{isClickedValidSorting && <CheckIcon />}</CheckBox>
          <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{t('messageSend.memberSelect.filter.valid')}</Text>
        </Option>
        <Option onClick={() => setIsClickedInvalidSorting(!isClickedInvalidSorting)}>
          <CheckBox isClicked={isClickedInvalidSorting}>{isClickedInvalidSorting && <CheckIcon />}</CheckBox>
          <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{t('messageSend.memberSelect.filter.expired')}</Text>
        </Option>
      </SelectBox>
    </StatusBoxWrapper>
  )
}

const StatusBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const StatusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: ${props => props.$hasSelected ? 'flex-start' : 'space-between'};
  align-items: center;

  padding: 0px 10px;

  box-sizing: border-box;
  width: ${props => props.$hasSelected ? 'fit-content' : 'none'};
  height: 30px;

  gap: 8px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.buttonFill}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.subBackground : props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 6px;
  height: 11px;

  transition: all 0.3s ease-in-out;

  transform: ${props => props.isClicked ? `rotateZ(90deg)` : `rotateZ(-90deg)`};
`;

const StyledArrow = styled(LeftArrow)`
  width: 100%;
  height: 100%;
  flex-shrink: 0;

  color: ${props => props.$isClicked ? props.theme.primary : props.theme.subText};

  transition: all 0.3s ease-in-out;
`;

const SelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0 5px;
  margin-top: 37px;

  width: fit-content;
  height: ${props => props.isClicked ? `70px` : `0px`};

  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border-radius: 5px;
  border: 1px solid ${props => props.isClicked ? props.theme.primary : 'transparent'};
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0;

  height: 35px;

  gap: 6px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckIcon = styled(Check3Svg)`
  width: 10px;
  height: 8px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const CheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 16px;
  height: 16px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;
